import { memo } from 'react';
import { EditableCell } from './EditableCell';
import { getBaseStatus } from '@/utils/projectStatuses';
import type { Project } from '@/api/client';
import { highlightPlainText } from '@/utils/highlightSearchTerms';

interface PagesCellProps {
  project: Project;
  searchHighlightWords?: string[];
}

export const PagesCell = memo(function PagesCell({ project, searchHighlightWords }: PagesCellProps) {
  const totalPages = project.pages ?? 0;
  const baseStatus = getBaseStatus(project.state);
  const isRecording = baseStatus === 'Запись';
  const soloReader = (project.readers?.length ?? 0) === 1;
  const showReadProgress = isRecording && project.project_type !== 'Podcast' && soloReader;
  const pagesRead = showReadProgress ? (project.readers![0].pages_read ?? 0) : 0;

  const hl = (t: string | number) =>
    searchHighlightWords?.length ? highlightPlainText(String(t), searchHighlightWords) : String(t);

  const display = totalPages > 0 ? (
    <div className="projects-table__pages-cell">
      <span className="projects-table__pages-label">
        {showReadProgress ? 'Прочитано' : 'Страниц:'}
      </span>
      <span className="projects-table__pages-value">
        {showReadProgress ? (
          <>
            <strong>{hl(pagesRead)}</strong>
            <span className="projects-table__pages-sep"> из </span>
            <strong>{hl(totalPages)}</strong>
          </>
        ) : (
          <strong>{hl(totalPages)}</strong>
        )}
      </span>
    </div>
  ) : null;

  return (
    <EditableCell project={project} fieldKey="pages">
      {display ?? <span className="projects-table__empty-value">N/A</span>}
    </EditableCell>
  );
});
